import React, { Dispatch, SetStateAction, useState } from 'react'
import { getPoll } from '../api/poll'
import { IPoll } from '../api/types'

const emptyPoll: IPoll = {
    uuid: '',
    createdAt: new Date(),
    updatedAt: new Date(),
    image: '',
    showTitle: true,
    status: 'published',
    title: 'Sport1',
    questions: [],
}

export const usePollLoader = (
    pollID: string,
    fallback: () => void
): [boolean, IPoll, [Dispatch<SetStateAction<boolean>>, Dispatch<SetStateAction<IPoll>>]] => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [poll, setPoll] = useState<IPoll>(emptyPoll)

    React.useEffect(() => {
        const initPoll = async () => {
            try {
                if (!pollID) throw new Error()
                const fetchedPoll = await getPoll(pollID)
                if (fetchedPoll && fetchedPoll.data) {
                    setPoll(fetchedPoll.data as IPoll)
                    setIsLoaded(true)
                }
            } catch (err) {
                fallback()
            }
        }
        initPoll()
    }, [pollID, fallback])

    return [isLoaded, poll, [setIsLoaded, setPoll]]
}
